import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';

import { dropTask } from 'ember-concurrency';

import { MainLayout } from 'register-partners-js/react/components/layouts/main';
import { NatureOfOps } from 'register-partners-js/react/components/nature-of-ops/nature-of-ops';

import styles from './styles.module.css';

export default class OrganizationNatureOfOpsController extends Controller {
  mainLayout = MainLayout;

  form = NatureOfOps;

  @service apiFlowManager;
  @service router;
  @service segment;
  @service store;

  submitTask = dropTask(async sortedNatureOfOperations => {
    let { organization } = this.model;

    organization.natureOfOperations = sortedNatureOfOperations;

    try {
      await organization.save();
      // To be removed when backend removes `features` property from organization PATCH
      await this.store.findAll('organization');

      this.segment.track('onboarding_partner_register_nature_of_ops_submitted', {
        nature_of_ops: sortedNatureOfOperations,
      });
    } catch {
      /* empty */
    }

    let registrationId = this.model.registration.id;

    return this.router.transitionTo('react', `registrations/${registrationId}/business-activity`);
  });

  @action
  handleGoBack() {
    if (this.apiFlowManager.isPartnersService) {
      return this.router.transitionTo('registration.start');
    } else {
      return this.router.replaceWith('registration.phone-number');
    }
  }

  styles = styles;
}
